module.exports = __webpack_public_path__ + "static/media/light-towers.bc89f45c.jpg";